import { where } from 'firebase/firestore';
import _ from 'lodash';
import { getFirstObject } from '../../../../../global/common/convert';
import { dataFix } from '../../../../../global/common/dataFix';
import { createRefPath_event } from '../../../../../global/firestoreData/appData/appRefPaths';
import { getSportsYear } from '../../../../../global/firestoreData/helpers/years';
import { ammend_sportsSeasonDataz, ammendSportsSeasonDatas } from './seasonSportsData';
import { _deleteMatchProps, _deleteMatchResultProps } from './seasonalDataHelpers';
import { _seasonalCollectionName } from 'projectSpecific/sports/useHelpers/useSeasonals';

export const _requiredMatchProps = ['away', 'home', 'levels', 'sections', 'startDate', 'startTime']

const _pksScores = ['organizations', 'districts', 'sports', 'sportsYears']

const _seasonalCollections = {
  districts: 'districts',
  organizations: 'organizations',
  schools: 'schools',
  sports: 'sports',
  teams: 'teams',
  tournaments: 'tournaments',
}

const modifyParentKeys = (pks) => {
  if (!pks) return false;
  _.forEach(pks, (pk, key) => {
    if (!_pksScores.includes(key)) {
      delete pks[key]
    }
  })
}

const checkParentKeys = (pks) => {
  let allow = true
  if (Object.keys(pks).length === _pksScores.length) {
    _pksScores.forEach(pk => {
      if (!pks[pk]) {
        allow = false
      }
    })
    return allow
  } else {
    return false
  }
}


const ammend_updateProps = (updateProps, pks, callback) => {
  updateProps.pks = pks
  updateProps.callback = callback
}

const ammend_updateNameProps = (updateProps, collectionName, documentFieldName, data, opts) => {
  if (collectionName) { updateProps.collectionName = collectionName }
  if (documentFieldName) { updateProps.documentFieldName = documentFieldName }
  if (data) {
    updateProps.data = data
    updateProps.dataToUpdate = data
  }
  if (opts) { updateProps.opts = opts }
  updateProps.forSeasonal = !updateProps.collectionName ? true : false
}



/**
 * Gets the data based on the refPath_event and the collectionName with dataParents creating wheres
 * @param {string} pathViews 
 * @param {object} dataParents 
 * @param {string} collectionName 
 * @returns 
 */
const getSeasonalForUpdate = async (database_fns, pathViews, dataParents, collectionName) => {

  if (dataParents) {
    const _refPath = createRefPath_event(pathViews, [collectionName])
    const wheres = []

    dataParents.forEach(dp => {
      switch (dp) {
        case 'allSportsYears':
          const sy = getSportsYear()
          wheres.push(where('parentKeys.sportsYears', '==', sy))
          break;
        default:
          if (pathViews[dp]) {
            wheres.push(where('parentKeys.' + dp, '==', pathViews[dp]))
            // firestoreRef = firestoreRef.where('parentKeys.' + dp, '==', pathViews[dp])
          }
      }
    })

    const retData = await database_fns.get_data({ refPath: _refPath, wheres })
    return retData
  } else {
    return null
  }
}

/**
 * 
 * @param {object} parentKeys 
 * @param {array} dataParents 
 * @param {string} collectionName 
 * @returns the data from the collectionName or _seasonalCollectionName via callback
 */
const getSports_collectionItem = async (database_fns, pathViews, parentKeys, collectionName, returnFirstObject, cbProps, callback, collectionKeys) => {

  const cb = (data) => {
    const cbd = {
      collectionName,
      parentKeys,
      data_sportsCollectionItem: data
    }
    callback(cbd, { cbProps })
  }

  const _collectionName = collectionName ? collectionName : _seasonalCollectionName

  const _refPath = collectionKeys ? createRefPath_event(pathViews, [_collectionName, collectionKeys[0], collectionKeys[1]]) : createRefPath_event(pathViews, [_collectionName])

  const wheres = []
  const wherez = []

  Object.keys(parentKeys).forEach(pk => {
    switch (pk) {
      // case 'organzations':
      // case 'districts':
      // case 'sports':
      //   wheres.push(where('parentKeys.' + pk, '==', parseInt(parentKeys[pk])))
      //   break;
      case 'sportsYears':
        wheres.push(where('parentKeys.' + pk, '==', parseInt(parentKeys[pk])))
        wherez.push({ pk, value: parseInt(parentKeys[pk]) })
        break;
      default:
        wheres.push(where('parentKeys.' + pk, '==', parentKeys[pk]))
        wherez.push({ pk, value: parentKeys[pk] })
    }
  })

  if (database_fns) {
    if (callback) {
      database_fns.get_data({ refPath: _refPath, callback: cb, wheres, opts: { returnFirstObject } })
    } else {
      const retData = await database_fns.get_data({ refPath: _refPath, wheres, opts: { returnFirstObject } })
      return retData
    }
  }
}



const getPks = (pathViews, year_current, sportsKey, ignores) => {
  const _pks = {}
  Object.keys(pathViews).forEach(pv => {
    let allow = true
    if (ignores && ignores.includes(pv)) {
      allow = false
    }
    if (allow) {
      switch (pv) {
        case _seasonalCollections.districts:
        case _seasonalCollections.organizations:
        case _seasonalCollections.schools:
        case _seasonalCollections.sports:
        case _seasonalCollections.teams:
        case _seasonalCollections.tournaments:
          if (pathViews[pv]) {
            _pks[pv] = pathViews[pv]
          }
          break;
        default:
        // nothing
      }
    }
  })

  if (sportsKey) { _pks['sports'] = sportsKey }
  if (year_current) { _pks['sportsYears'] = parseInt(year_current) }
  return _pks
}

const isValidPks = (pks) => (pks.districts && pks.organizations && pks.sports && pks.sportsYears) ? true : false

const cleanMatchesForUpdate = (matches) => {

  if (!matches) return;

  _.forEach(matches, (match) => {
    // Remove top-level match props
    _.forEach(_deleteMatchProps, (prop) => {
      _.unset(match, prop);
    });

    const _match = dataFix.removeFalsyValues(match)

    const results = _.get(_match, 'results');

    if (_.isObject(results)) {
      // Remove shallow result props
      _.forEach(_deleteMatchResultProps, (prop) => {
        _.unset(results, prop);
      });

      const score = _.get(results, 'score');
      const home = _.get(score, 'home');
      const away = _.get(score, 'away');

      const validHome = _.isFinite(home);
      const validAway = _.isFinite(away);

      if (!(validHome && validAway)) {
        _.unset(match, 'results');
      }
    }
  });
};


const filterValidMatches = (dataToUpdate, requiredProps) => {
  return _.pickBy(dataToUpdate, (match) =>
    _.every(requiredProps, (prop) => _.has(match, prop))
  );
};


const getResultsFromMatchDay = (results_matchDay, matches, matches_playoffs) => {

  const mtu = {}
  const matchDayResults = {}

  if (results_matchDay) {
    _.forEach(results_matchDay, (rmd, matchKey) => {
      const { item, fk } = getFirstObject(rmd)
      let email;
      try {
        email = atob(fk);
      } catch (error) {

      }
      const { results } = item
      // find the match
      if (matches && matches[matchKey]) {
        const _match = _.cloneDeep(matches[matchKey])
        _match.results = results
        _match.status = {
          displayName: email
        }
        mtu[matchKey] = _match
      }
      if (matches_playoffs && matches_playoffs[matchKey]) {
        const _playoffMatch = _.cloneDeep(matches_playoffs[matchKey])
        _playoffMatch.results = results
        mtu[matchKey] = _playoffMatch
      }
    })
  }

  const mtu_grouped = _.groupBy(mtu, 'levels')

  _.forEach(mtu_grouped, (matches, levelKey) => {
    _.forEach(matches, (match) => {
      const { isPlayoff, _itemKey } = match
      if (isPlayoff) {
        if (!matchDayResults.seasonPlayoff) { matchDayResults.seasonPlayoff = {} }
        if (!matchDayResults.seasonPlayoff[levelKey]) { matchDayResults.seasonPlayoff[levelKey] = {} }
        matchDayResults.seasonPlayoff[levelKey]['playoffMatches.' + _itemKey] = match
      } else {
        if (!matchDayResults.season) { matchDayResults.season = {} }
        if (!matchDayResults.season[levelKey]) { matchDayResults.season[levelKey] = {} }
        matchDayResults.season[levelKey]['matches.' + _itemKey] = match
      }
    })
  })

  return matchDayResults

}

const formatMatchesForUpdate = (matches, noLocation) => {
  const matchLevelGroups = _.groupBy(matches, '_matchCollectionKey')
  const groupedMatches = {}
  _.forEach(matchLevelGroups, (matches, levelKey) => {
    if (!groupedMatches[levelKey]) {
      groupedMatches[levelKey] = {}
    }
    _.forEach(matches, (match) => {
      const { isPlayoff, _itemKey } = match
      if (isPlayoff) {
        groupedMatches[levelKey]['playoffMatches.' + _itemKey] = match
      } else {
        groupedMatches[levelKey]['matches.' + _itemKey] = match
      }
    })
  })
  return groupedMatches
}

export const seasonalHelpers = {
  ammend_sportsSeasonDataz,
  ammendSportsSeasonDatas,
  ammend_updateNameProps,
  ammend_updateProps,
  cleanMatchesForUpdate,
  formatMatchesForUpdate,
  getPks,
  getResultsFromMatchDay,
  isValidPks,
}
